import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAngleRight } from "@fortawesome/free-solid-svg-icons"

export const AngleRight = (props) => {
  return <FontAwesomeIcon faIcon={faAngleRight} {...props} />
}
